const loginRoutes = [{
  id: 'login',
  text: 'logIn',
  link: '/login',
}, {
  id: 'activate-account',
  text: 'activateAccount',
  link: '/activate-account',
}, {
  id: 'change-password',
  text: 'changePassword',
  link: '/change-password',
}, {
  id: 'forgot-password',
  text: 'sendOneTimeLink',
  link: '/forgot-password',
  returnId: 'login',
}, {
  id: 'select-org',
  text: 'chooseCompanyToMoveOn',
  link: '/select-org',
}, {
  id: 'update-account',
  text: 'weveImprovedOurUserAccounts',
  link: '/update-account',
}];

export const getLink = (id) => {
  const links = loginRoutes.filter((route) => route.id === id).map((route) => route.link);
  if (links.length !== 1) {
    throw new Error('Invalid id in call for route link or invalid route specification for login routes.');
  }
  return links[0];
};

export const getTitle = (link) => {
  const titles = loginRoutes.filter((route) => route.link === link).map((route) => route.text);
  if (titles.length !== 1) {
    throw new Error('Invalid link in call for route title or invalid route specification for login routes.');
  }
  return titles[0];
};

export const getReturn = (link) => {
  const returnItems = loginRoutes.filter((route) => route.link === link && route.returnId);
  if (returnItems.length === 0) return null;
  if (returnItems.length > 1) throw new Error('Invalid route specification for login routes.');
  const { returnId } = returnItems[0];
  const returnLink = getLink(returnId);
  const returnTitle = getTitle(link);
  return { link: returnLink, title: returnTitle };
};
